import React, { FC } from 'react'
import styles from 'styles/components/typography.module.scss'
import text from 'styles/utility/text.module.scss'
import HTMLReactParser from 'html-react-parser'
import classNames from 'classnames'
import { returnCodeToBr } from 'lib/helper'

type Props = {
  align?: 'center' | 'left' | 'right'
  description: string
  fontWeight?: 'normal' | 'bold'
}

const Description: FC<Props> = React.memo((props) => {
  const { align, description, fontWeight = 'normal' } = props
  const alignStyle = align ? text['align_' + align] : ''
  const fontWeightStyle = fontWeight === 'bold' ? text.font_bold : ''

  return (
    <p className={classNames(styles.description, alignStyle, fontWeightStyle)}>
      {HTMLReactParser(returnCodeToBr(description))}
    </p>
  )
})

export default Description
